export default "__VITE_ASSET__DmFCOKdj__"